import {
  UIBox,
  Button,
  UICard,
  UIGrid,
  Input,
  Typography,
  Radio,
  Autocomplete,
} from '@/components/UI';
import { theme } from '@/constants';
import { JobPostingSteps } from '@/enums';
import { ProjectJson } from '@/types';

interface NewJobStep3Props {
  job: ProjectJson.Project;
  onClickNext?: () => void;
  onClickPrev?: () => void;
  updateJob: (updated: Partial<ProjectJson.Project>) => void;
}
const NewJobStep3: React.FC<NewJobStep3Props> = ({
  onClickNext,
  onClickPrev,
}) => {
  return (
    <UICard
      id={JobPostingSteps.STEP_3}
      borderRadius={10}
      display="flex"
      flexDirection="column"
      gap={20}
      p={2}
    >
      <Typography variant="h6" marginBottom={0}>
        More about job
      </Typography>
      <Autocomplete label="What kind of industry will it need?" fullWidth />
      <Autocomplete
        label="What level of proficiency are you looking for?"
        fullWidth
      />
      <UIGrid columns={2} gap={20}>
        <Autocomplete label="What kind of job type will it need?" fullWidth />
        <Autocomplete
          label="What kind of employment type will it need?"
          fullWidth
        />
      </UIGrid>
      <UIBox mb={0.5} />
      <Typography variant="h6" marginBottom={0}>
        Budget
      </Typography>
      <UIBox display="flex" gap={30}>
        <Radio label="Fixed Budget" />
        <Radio label="Hourly Budget" />
      </UIBox>
      <UIGrid columns={2} gap={20}>
        <Input label="Min salary (K)" fullWidth />
        <Input label="Max salary (K)" fullWidth />
      </UIGrid>
      {onClickNext && (
        <UIBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mt={2}
        >
          <UIBox display="flex" alignItems="center" gap={20}>
            <Button variant="secondary" onClick={onClickPrev} size="sm">
              Back
            </Button>
            <Typography>
              <Typography variant="span" color={theme.colors.textPrimary}>
                3
              </Typography>
              /5
            </Typography>
          </UIBox>
          <Button size="sm" onClick={onClickNext}>
            Next
          </Button>
        </UIBox>
      )}
    </UICard>
  );
};

export default NewJobStep3;
